'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024 from "./presto.types$-Restricted-Domain-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$14() {
  this.beT = null;
  this.beR = null;
  this.beS = false;
  this.beP = null;
  this.beQ = false;
  this.beU = false;
  this.beV = false;
  this.beT = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$14 as $c_Lpresto_PrestoRouter$$anon$14 };
$p = $c_Lpresto_PrestoRouter$$anon$14.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$14;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$14() {
}
export { $h_Lpresto_PrestoRouter$$anon$14 as $h_Lpresto_PrestoRouter$$anon$14 };
$h_Lpresto_PrestoRouter$$anon$14.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.beT;
});
$p.t = (function() {
  if ((!this.beS)) {
    this.beR = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.beS = true;
  }
  return this.beR;
});
$p.ae = (function() {
  if ((!this.beQ)) {
    this.beP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024.$m_Lpresto_types$RestrictedDomainId$().GI(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().iZ, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.beQ = true;
  }
  return this.beP;
});
$p.w = (function() {
  if ((!this.beV)) {
    this.beU = false;
    this.beV = true;
  }
  return this.beU;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$14 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$14, "presto.PrestoRouter$$anon$14", ({
  NE: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$14 as $d_Lpresto_PrestoRouter$$anon$14 };
//# sourceMappingURL=presto.-Presto-Router$$anon$14.js.map
